import React from "react";

function NavlogWeatherLinks({
  winds,
  metar,
  taf,
  afd,
  mvar,
}) {
  return (
    <div style={{ marginTop: "8px", textAlign: "left" }}>
      <div style={{ marginTop: "6px" }}>
      <a href={winds} target="_blank" rel="noopener noreferrer">
        Winds Aloft
      </a>
      </div>

      <div style={{ marginTop: "6px" }}>
      <a href={metar} target="_blank" rel="noopener noreferrer">
        METAR
      </a>
      </div>

      <div style={{ marginTop: "6px" }}>
      <a href={taf} target="_blank" rel="noopener noreferrer">
        TAF
      </a>
      </div>

      

      <div style={{ marginTop: "6px" }}>
      <a href={mvar} target="_blank" rel="noopener noreferrer">
        Magnetic Variation (Declination)
      </a>
      </div>
      
    </div>
  );
}

export default NavlogWeatherLinks;